const initialState = {
    dataAgencys:[],
    dataAgency:'',
    modalAgency: false,
    formAgency: {
        Id:null,
        Name:'',
        ShortName:'',
        Code:'',
        FileLogo:'',
        Email:'',
        Website:'',
        Contact:'',
        UrlFriendly:'',
        PhoneNumber:'',
        Address:'',
        Description:'',
        SectorId:'',
        Sector:''
    },
    formDataset: {
        Id:null
    }

}

const organisasiReducer = (state = initialState, action) => {
    switch (action.type) {
        case 'MODAL_AGENCY':
            return { ...state, modalAgency: action.payload }
        case 'DATA_AGENCYS':
            return { ...state, dataAgencys: action.payload }
        case 'DATA_AGENCY':
            return { ...state, dataAgency: action.payload }
        case 'RESET_FORM_AGENCY':
            return { ...state, formAgency: initialState.formAgency }
        case 'FORM_AGENCY':
            return {
                ...state,
                formAgency: {
                    ...state.formAgency,
                    [action.formType]: action.formValue
                }
            }
        default:
            return state
    }
}

export default organisasiReducer;